module.exports = __webpack_public_path__ + "img/Group 1674@2x.abc62560.png";